import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

//import { getFirestore} from 'firebase/firestore/lite';

//import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyACHL8vLxdy4AszyhLJycb35vjiEHA2cuc",
    authDomain: "tlapaleriapiedra-d8c04.firebaseapp.com",
    projectId: "tlapaleriapiedra-d8c04",
    storageBucket: "tlapaleriapiedra-d8c04.appspot.com",
    messagingSenderId: "1037888914489",
    appId: "1:1037888914489:web:faf0ae242a9a2be9e0f9e8",
    measurementId: "G-S0G6B53RJZ"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
//const db = getFirestore(app);
//exports
export {
    app,
    storage
}